/* Copyright (c) 2020-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import * as yup from "yup";

export const SchemaExternalIntegration = yup.object().shape({
  name: yup.string().required(),
  ownerId: yup.string().required(),
});
